import { Link } from 'react-router-dom';
import {AiTwotoneStar} from 'react-icons/ai'
import { Row, Col, Container, Spinner, Button } from 'reactstrap';
import { formatTimestampInterval } from '../../common/formatters';

const now = () => new Date().getTime()

export default (props) => {
    const {dashboards, status} =  props ;

    const dashboardsTable = () => { return (
        <Container className="w-full">            
                <Row className='header-row'>
                    <Col className='m-2'>Name</Col>
                    <Col className='m-2'>Author</Col>
                    <Col className='m-2'>Created</Col>
                    <Col className='m-2'>Last modified</Col>
                </Row>
            {
                dashboards.map((d,i) => (                   
                    <Link to={`/dashboard/${d.id}`}>
                        <Row className={`grid-row ${(i%2 ? 'odd-row' : 'even-row')}`} key={d.id}>
                            <Col className='m-2'>{d.name}{d.isFavorite ? <AiTwotoneStar className='fav-indicator ml-1'/> : ''}</Col>                                
                            <Col className='m-2'>{d.authorName}</Col>
                            <Col className='m-2'>{formatTimestampInterval(d.created, now())}</Col>
                            <Col className='m-2'>{formatTimestampInterval(d.modified, now())}</Col>
                        </Row>  
                    </Link>                  
                ))
            }
            
        </Container>
    )};

    const loadingIndicator = () => {return (
        <><Spinner /> Loading...</>
    )};

    const noRecordsIndicator = () => {return (
        <p>No custom dashboards to display.</p>
    )}
    const loading = status == 'loading';
    return (        
        <Container>
            <Row className="pt-3">                
                <h2 className="mt-0 ml-3">Custom Dashboards</h2>
                <Col mr="auto" ml="auto"></Col>
                <Col md="auto">                                                
                    <Link to="/dashboardeditor">
                        <Button className="ml-2">Open Builder</Button>
                    </Link>                                                   
                </Col>                
            </Row>
            <Row className='mt-2 mb-5'>
                <Col className='pl-3'>
                    {loading ? loadingIndicator() : dashboardsTable()}
                    {(dashboards == null || dashboards.length == 0) && !loading && noRecordsIndicator() }
                </Col>
            </Row>
        </Container>
    )
}